import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan variables de entorno de Supabase')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Tipos para tablas de la base de datos
export interface Database {
  public: {
    Tables: {
      personas: {
        Row: {
          id: string
          organization_id: string
          nombre: string
          rol: string
          descripcion: string | null
          config_voz: Record<string, unknown> | null
          areas_experiencia: string[] | null
          plataformas: string[] | null
          created_at: string
        }
      }
      content_tasks: {
        Row: {
          id: string
          organization_id: string
          estado: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled'
          tipo_contenido: string
          canal: string
          persona_id: string
          tema: string
          brief: string
          created_at: string
          completed_at: string | null
        }
      }
      organizations: {
        Row: {
          id: string
          name: string
          monthly_budget_limit: number
          created_at: string
          updated_at: string
        }
      }
      user_profiles: {
        Row: {
          id: string
          organization_id: string | null
          full_name: string | null
          role: string | null
          created_at: string
          updated_at: string
        }
      }
    }
  }
}
